// extracted by mini-css-extract-plugin
export default {"root":"AddSuperBatchModuleButton_root__kjdYi"};